import { render, staticRenderFns } from "./UploadEmployeeCard.vue?vue&type=template&id=f2cc8998&scoped=true&"
import script from "./UploadEmployeeCard.vue?vue&type=script&lang=js&"
export * from "./UploadEmployeeCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadEmployeeCard.vue?vue&type=style&index=0&id=f2cc8998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cc8998",
  null
  
)

export default component.exports